import { Link } from "react-router-dom";

export function Footer({ note }) {
    return (
        <footer className="mt-16 border-t border-border/70">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid gap-8 md:grid-cols-3 text-sm">
                <div>
                    <p className="font-display text-xl">Aditya Baheti</p>
                    <p className="text-muted-foreground mt-2">Legal Academic & Researcher</p>
                    <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground mt-4">NLU Jodhpur</p>
                </div>
                <div className="space-y-2">
                    <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground">Explore</p>
                    <ul className="space-y-1">
                        <li><Link className="link-underline" to="/about">About</Link></li>
                        <li><Link className="link-underline" to="/research">Research</Link></li>
                        <li><Link className="link-underline" to="/teaching">Teaching</Link></li>
                        <li><Link className="link-underline" to="/cv">CV</Link></li>
                        <li><Link className="link-underline" to="/contact">Contact</Link></li>
                    </ul>
                </div>
                <div className="space-y-2">
                    <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground">Elsewhere</p>
                    <ul className="space-y-1">
                        <li><a className="link-underline" href="https://www.linkedin.com/in/aditya-baheti-0796" rel="noreferrer noopener" target="_blank">LinkedIn</a></li>
                        <li><a className="link-underline" href="https://orcid.org/0009-0007-7065-0278" rel="noreferrer noopener" target="_blank">ORCID</a></li>
                        <li><a className="link-underline" href="https://papers.ssrn.com/sol3/cf_dev/AbsByAuth.cfm?per_id=7711291" rel="noreferrer noopener" target="_blank">SSRN</a></li>
                    </ul>
                </div>
            </div>
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pb-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-muted-foreground">
                <p>{note || "© Aditya Baheti. Built with care."}</p>
                <Link to="/admin" className="link-underline" data-testid="footer-admin-link">Admin</Link>
            </div>
        </footer>
    );
}
